import { render } from "./ShowInstrumentForm.vue?vue&type=template&id=5fb6a002"
import script from "./ShowInstrumentForm.vue?vue&type=script&lang=js"
export * from "./ShowInstrumentForm.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__